
export const mySetTimeout = time => new Promise(resolve => setTimeout(resolve, time));
export const horizontalScreen = (app, container) => {
    let evt = "onorientationchange" in window ? "orientationchange" : "resize";
    window.addEventListener(evt, rotate, { passive: false })
    const SW = app.SW;
    const SH = app.SH;
    async function rotate() {
        await mySetTimeout(100);
        let width = window.innerWidth;
        let height = window.innerHeight;
        app.renderer.autoResize = true;
        if (width > height) {
            app.renderer.resize(SW, SH);
            container.pivot.set(SW / 2, SH / 2);
            container.angle = 0;
            container.position.set(SW / 2, SH / 2);
        } else {
            app.renderer.resize(SH, SW);
            container.angle = 90;
            container.pivot.set(SW / 2, SH / 2);
            container.position.set(SH / 2, SW / 2);
        }
    }
}

export const createImageBitmap = (resources, name, isTwo = true) => {
    let container = new PIXI.Container();
    let item = new PIXI.Sprite(resources[name].texture);
    isTwo && item.scale.set(2, 2);
    item.buttonMode = true;
    item.interactive = true;
    item.anchor.set(.5);
    container.addChild(item);
    return container
}


export const createSpriteImageBitmap = (name, isTwo = true) => {
    let container = new PIXI.Container();
    let item = new PIXI.Sprite(PIXI.Texture.from(`${name}@2x.png`));
    //isTwo && item.scale.set(2, 2);
    item.buttonMode = true;
    item.interactive = true;
    item.anchor.set(.5);
    container.addChild(item);
    return container
}


export const drawRect = (options) => {
    let { x = 0, y = 0, width = 100, height = 100 } = options;
    let rectangle = new PIXI.Graphics();
    rectangle.beginFill(0x66CCFF);
    rectangle.alpha = 0;
    rectangle.drawRect(0, 0, width, height);
    rectangle.endFill();
    rectangle.x = x;
    rectangle.y = y;
    rectangle.buttonMode = true;
    rectangle.interactive = true;
    return rectangle;
}


function getAngle(angx, angy) {
    return Math.atan2(angy, angx) * 180 / Math.PI;
};
//根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动

export const getDirection=(startx, starty, endx, endy)=>{
    var angx = endx - startx;
    var angy = endy - starty;
    var result = 0;

    //如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
        return result;
    }

    var angle = getAngle(angx, angy);
    if (angle >= -135 && angle <= -45) {
        result = 1;
    } else if (angle > 45 && angle < 135) {
        result = 2;
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
        result = 3;
    } else if (angle >= -45 && angle <= 45) {
        result = 4;
    }
    
    return result;
}




export const collisionCheck = (obj1, obj2) => {
    let l1 = obj1.x + obj1.getBounds().width / 2;
    let t1 = obj1.y - obj1.getBounds().height / 2;
    let r1 = l1 + obj1.getBounds().width;
    let b1 = t1 + obj1.getBounds().height;

    let l2 = obj2.x + obj2.getBounds().width / 2;
    let t2 = obj2.y - obj2.getBounds().height / 2;
    let r2 = l2 + obj2.getBounds().width;
    let b2 = t2 + obj2.getBounds().height;

    if (l1 > r2 || b1 < t2 || r1 < l2 || t1 > b2) {
        return true  //没碰上
    } else {
        return false
    }
}

export const listerMusic=(music,isCreate,musicSrc,musicStop)=>{

    //   document.addEventListener("WeixinJSBridgeReady", function() {
    //         WeixinJSBridge.invoke('getNetworkType', {}, function() {
    //             _xx.oMedia.play();
    //         })
    //     }, false);

    !isCreate&&music.play();
    let isPlay=false;

    music.on('play',()=>{
        $('.music').attr('src',musicSrc);
        $('.music').addClass('animate')
        isPlay=true;
    });

    music.on('pause',()=>{
        $('.music').attr('src',musicStop);
        $('.music').removeClass('animate')
        isPlay=false;
    })

    $('.music').on('click',()=>{
        isPlay=!isPlay;
        if(isPlay){
            music.play();
            $('.music').addClass('animate')
            $('.music').attr('src',musicSrc)
        }else {
            music.pause();
            $('.music').attr('src',musicStop)
            $('.music').removeClass('animate')
        }
    })

}


export const isLongPhone=()=>window.innerWidth/window.innerHeight<0.52?true:false;

export const drawText = (options) => {
    let {text='',x=0,y=0,style={
        fontSize:30,
        fontWeight:'bold',
        fontFamily:"Arial",
        fill:["#f37207"],
    }} = options;
    const styles = new PIXI.TextStyle(style);
    const richText = new PIXI.Text(text, styles);
    richText.anchor.set(.5);
    richText.x = x;
    richText.y = y;
    return richText;
}

export const drawTextToImage=(textOptions,imageOptions)=>{
        let image =createImageBitmap(...imageOptions);
        let texts = textOptions.map(options=>drawText(textOptions));
        image.addChild(...texts)
        return  image
}



export const createStepSprite= (options)=>{
    let { frameName,frameLength, speed = .2, point = {},resources,end,loop={}} = options;
    const frames = [];
    const container=new PIXI.Container();
    let str=`^`+frameName+`\\d+$`;
    let reg=new RegExp(str);
    let loopAni,loopFrames;
    for(let i=1;i<=frameLength; i++){
        // frames.push(PIXI.Texture.from(`box${i}.png`))
         frames.push(PIXI.Texture.from(`${frameName}${i}.png`))       
     }

    let startFrames= frames.slice(0,end);
    let startAni = new PIXI.AnimatedSprite(startFrames);
    if(point.y==='false')point.y=(point.SH-startAni.height)/2
    Object.assign(startAni.position, point);
    if(loop!=false){
        loopFrames= frames.slice(loop.start,loop.end);
        loopAni = new PIXI.AnimatedSprite(loopFrames);
        Object.assign(loopAni.position, point);
       
        loopAni.anchor.set(0.5);
        loopAni.animationSpeed = speed;
        loopAni.alpha=0;
    }
    startAni.anchor.set(0.5);
    startAni.animationSpeed = speed;
    startAni.loop=false;
    container.addChild(startAni);
    if(loop!=false){
        container.addChild(loopAni);
    }
   
    
    container.playAnimate=()=>{
        startAni.play();
        if(loop!=false){
            startAni.onComplete=()=>{
                startAni.alpha=0;
                loopAni.alpha=1;
                loopAni.play();
            }
        }
    }
    container._el=startAni;
    return container
}



export const createSwitchSprite= (options)=>{
    let { frameName,frameLength, speed = .2, point = {},end,loop={}} = options;
    const frames = [];
    const container=new PIXI.Container();
    let loopAni,loopFrames;
    for(let i=1;i<=frameLength; i++){
        // frames.push(PIXI.Texture.from(`box${i}.png`))
         frames.push(PIXI.Texture.from(`${frameName}${i}.png`))       
     }

    let startFrames= frames.slice(0,end);
   // console.log(frames);

    let startAni = new PIXI.AnimatedSprite(startFrames);
    if(point.y==='false')point.y=(point.SH-startAni.height)/2;
    Object.assign(startAni.position, point);
    if(loop!=false){
        loopFrames= frames.slice(loop.start,loop.end);
        loopAni = new PIXI.AnimatedSprite(loopFrames);
        loopAni.anchor.set(0.5);
        loopAni.animationSpeed = speed;
        loopAni.alpha=0;
    }
    startAni.anchor.set(0.5);
    startAni.animationSpeed = speed;
    startAni.loop=false;
    container.addChild(startAni);
    if(loop!=false){
        container.addChild(loopAni);
    }
    
    container.playAni=()=>{
        startAni.alpha=0;
        loopAni.alpha=1;
        loopAni.play();
    }
    container.stopAni=()=>{
        loopAni.stop();
        loopAni.alpha=0;
        startAni.alpha=1;
    }
    return container
}



export const createSpritePoint = (options) => {
    let { frameName, speed = .2, point = {},isPlay=true, loop=true ,resources} = options
    const frames = [];
    let images=[];
    let str=`^`+frameName+`\\d+$`;
    let reg=new RegExp(str);
    for(let name in resources){
        if(reg.test(name)){
            images.push({[name]:resources[name]})
        }
    }
    for (let i = 0; i < images.length; i++) {
        // magically works since the spritesheet was loaded with the pixi loader
        frames.push(images[i][frameName+(i+1)].texture);
    }

    // create an AnimatedSprite (brings back memories from the days of Flash, right ?)

    const anim = new PIXI.AnimatedSprite(frames);
    if(point.y==='false')point.y=(point.SH-anim.height)/2
    Object.assign(anim.position, point)
    anim.anchor.set(0.5);
    anim.animationSpeed = speed;
    isPlay&&anim.play();
    anim.loop=loop;
    return anim
}


export const createSpriteTexturePoint = (options) => {
    let { frameName,frameLength, speed = .2, point = {},isPlay=true, loop=true,resource } = options;
    const frames = [];
    for(let i=1;i<=frameLength; i++){     
         frames.push(resource[`${frameName}${i}`].texture)       
     }
    const anim = new PIXI.AnimatedSprite(frames);
    
    if(point.y==='false')point.y=(point.SH-anim.height)/2
    Object.assign(anim.position, point)
    //anim.anchor.set(0.5);
    anim.animationSpeed = speed;
    isPlay&&anim.play();
    anim.loop=loop;
    return anim
}




















